module.exports = __webpack_public_path__ + "static/media/group-3@2x.76c62955.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/group-3@2x.jpg
// module id = 380
// module chunks = 0